import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { Calculation } from '../types/worksheet';

type GetCalculationsRequest = {
    allowAsSchedule?: boolean;
    page?: number;
    limit?: number;
    search?: string;
    sort?: string;
    filters?: string;
};

type GetCalculationsResponse = {
    calculations: Calculation[];
    totalItems: number;
};

async function getCalculations(workpaperId: string, params: GetCalculationsRequest): Promise<GetCalculationsResponse> {
    const { data } = await api.get(`/workpapers/${workpaperId}/worksheets/calculations?${params.filters}&${params.sort}`, {
        params: {
            allowAsSchedule: params.allowAsSchedule,
            page: params.page,
            limit: params.limit,
            search: params.search,
        },
    });
    return data;
}

export function useCalculations(
    params: GetCalculationsRequest = {},
    overrideWorkpaperId?: string
): UseQueryResult<GetCalculationsResponse, AxiosError> {
    const { id: contextWorkpaperId } = useWorkpaperContext();
    const workpaperId = overrideWorkpaperId || contextWorkpaperId;
    return useQuery(['workpapers', workpaperId, 'calculations', Object.values(params)], () => getCalculations(workpaperId, params), {
        keepPreviousData: true,
    });
}
